export const getViewId = (): string => {
    const urlParts = window.location.href.split("/");
    const viewsIndex = urlParts.indexOf("views");

    if (viewsIndex !== -1 && viewsIndex + 1 < urlParts.length) {
        const viewId = urlParts[viewsIndex + 1];
        // Use split to handle the case where # may or may not exist
        return viewId.split("#")[0];
    }

    return "";
};
